module.exports = __webpack_public_path__ + "logo-nl-c2ac87253d1717a50785.png";